<sh-modal
  id="contactModal"
  [label]="'Contact Information' | translate"
  modal-height="112px"
  modal-width="340px"
  class="modal"
>
  <div *ngIf="contactInfo && contactInfo.length > 0">
    <div *ngFor="let contact of contactInfo" style="padding-top: 8px">
      <div class="modal-wrapper">
        <sh-text style="text-decoration: underline">{{ contact }}</sh-text>

        <sh-icon
          id="target-1"
          icon="copy-results-to-clipboard"
          size="s"
          (click)="copyEmailToClipboard()"
          style="cursor: pointer"
        ></sh-icon>

        <sh-tooltip
          target="target-1"
          [label]="tooltipLabel"
          placement="right"
        ></sh-tooltip>
      </div>
    </div>
  </div>
</sh-modal>

<sh-tooltip
  target="target-1"
  label="Toggle Theme"
  placement="left"
></sh-tooltip>
<sh-tooltip
  target="target-2"
  label="Contact Information"
  placement="left"
></sh-tooltip>

<sh-access-bar [label]="'ExpertGuidance' | translate">
  <sh-icon
    button
    icon="disc-space-3"
    id="target-1"
    data-toggle="tooltip"
    label="Toggle Theme"
    slot="functions"
    (click)="onThemeToggleClick($event)"
  ></sh-icon>

  <sh-icon
    button
    icon="envelope"
    id="target-2"
    data-toggle="tooltip"
    slot="functions"
    onclick="document.querySelector('#contactModal').visible = true"
  >
  </sh-icon>
</sh-access-bar>
